import React, { Component } from "react";
import { connect } from "react-redux";
import M from "materialize-css/dist/js/materialize.min.js";
import Modal from "../helper/modal";
import { txURL,shortenHash} from "../../config";

let modalId = "modalPending";

let overflow = "hidden";
let textOverflow = "ellipsis";

class PendingTransactions extends Component {
  item(text,val,isURL){
    return(
      <div className="row mi">
        <h6 className='leftInfo'><b>{text}</b></h6>
        <h6 className="rightInfo">{isURL ?
          <a href={isURL} style={{ padding: 0, fontSize: "10px", color: "black", overflow, textOverflow, textDecoration: "underline"}} rel="noopener noreferrer" target="_blank">
            {val}
          </a>
          : val
        }</h6>
      </div>
    )
  }

  nrgURL(hash) {
    return ( this.props.settings.hostname + ":" + this.props.settings.port + "/#/tx/" + hash);
  }
  pendingTable() {
    let items = this.props.transactions.map((tx,i) => {
      if(tx.txHash) tx.hash = tx.txHash
      return (
        <>
          {this.item("Type",tx.type)}
          {this.item("Transaction Hash",shortenHash(tx.hash,15),tx.chain.toUpperCase() === "NRG" ? this.nrgURL(tx.hash) : txURL[tx.chain] + tx.hash)}
          {this.item("From",tx.from)}
          {this.item('To',tx.to)}
          {this.item('Amount',`${tx.amount} ${tx.chain}`)}
          {i+1 != this.props.transactions.length && <div className="row mi"> <hr/> </div>}
        </>
      );
    });
    return (
      <div className='row mbd' style={{ maxHeight: "350px", overflowY: "scroll" }}>
        {items}
      </div>
    );
  }
  openModal() {
    var instance = M.Modal.getInstance(document.querySelectorAll(`#modalPending`)[0]);
    instance.open();
  }
  render() {
    let num = this.props.pendingTransactions;
    if (num !== 0) {
      return (
        <li>
          <a className="pending rightLink" onClick={this.openModal.bind(this)}>PENDING TX ({num})</a>
          <Modal id={`modalPending`} style={{width:'500px'}} classes="modal" title={`Pending Transactions`} noClose={true} component={this.pendingTable()} />
        </li>
      );
    } else return null;
  }
}

function mapStateToProps(state, props) {
  let pendingTransactions = state.pending.transactions;
  let transactions = pendingTransactions ? Object.keys(pendingTransactions).map(key => pendingTransactions[key]) : [];
  pendingTransactions = transactions.length > 0 ? Object.keys(pendingTransactions).length : 0;

  // console.log({transactions})
  return {
    settings: state.settings.settings,
    transactions,
    pendingTransactions
  };
}

//
export default connect(
  mapStateToProps,
  {}
)(PendingTransactions);
